export enum EEidType {
  SE = 'eid:bankid',
  NemID = 'eid:nemid',
  NemIDKeyFile = 'eid:nemid-keyfile',
  NemIDOrg = 'eid:nemid-org',
  NO = 'eid:bankid-no',
  MitID = 'eid:mitid',
  BankIDFI = 'eid:bankid-fi',
}
